import PropTypes from 'prop-types';

import {Modal} from './modal';


class ModalContainer extends React.PureComponent {
  modals = {};

  static propTypes = {
    modalConfigs: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        confirmButtonText: PropTypes.string.isRequired,
        onConfirm: PropTypes.func.isRequired,
        body: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        cancelButtonText: PropTypes.string,
        isDangerous: PropTypes.bool,
      }),
    ).isRequired,
  };


  render () {
    return (
      <div>
        {this.props.modalConfigs.map(config => {
          return (
            <Modal
              {...config}
              key={config.id}
              ref={modal => {this.modals[config.id] = modal;}}
            />
          );
        })}
      </div>
    );
  }
}

function initialiseModals (...modalConfigs) {
  let container;
  ReactDOM.render(
    <ModalContainer modalConfigs={modalConfigs} ref={c => {container = c;}} />,
    document.querySelector('#modal-container'),
  );

  return container.modals;
}

export {initialiseModals, ModalContainer};
